import { ElementType, ReactNode } from "react";

import { cn } from "@verse_core/shared_components/ClassName";

type HeadingProps = {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  as?: ElementType;
};

export const Heading4XL = ({
  children,
  className,
  as: Component = "h2",
  dataTestId,
}: HeadingProps) => {
  return (
    <Component
      className={cn(
        "tw-font-degular tw-text-[4em] tw-font-medium tw-leading-none tw-tracking-[-0.01em] tw-text-gray-0",
        className,
      )}
      data-testid={dataTestId}
    >
      {children}
    </Component>
  );
};
